var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Form } from "../../../components/core/07-organisms/Form";
import { FormBar } from "../../../components/core/07-organisms/FormBar";
import { getText } from "../../../utils/translations/I18n";
import { WizardFormItem } from "./WizardFormItem";
/**
 *
 * @param props
 */
/**
 *
 */
var WizardForm = /** @class */ (function (_super) {
    __extends(WizardForm, _super);
    /**
     *
     * @param props
     */
    function WizardForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            items: props.items.map(function (item, index) { return (__assign(__assign({}, item), { isTouched: index === 0, isActive: index === 0, isLast: _this.props.items.length === index + 1 })); }),
            counter: 0,
        };
        _this.setActive = _this.setActive.bind(_this);
        return _this;
    }
    WizardForm.prototype.componentDidMount = function () {
        var _a, _b;
        (_b = (_a = this.props).getCardMetrics) === null || _b === void 0 ? void 0 : _b.call(_a, this.state.items.length > 0 ? {
            counter: this.state.counter,
            total: this.state.items.length,
        } : undefined);
    };
    WizardForm.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (this.props.items !== prevProps.items) {
            this.setState({
                items: this.props.items.map(function (item, index) {
                    var _a, _b, _c, _d;
                    return (__assign(__assign({}, item), { isTouched: (_b = (_a = _this.state.items) === null || _a === void 0 ? void 0 : _a[index].isTouched) !== null && _b !== void 0 ? _b : index === 0, isActive: (_d = (_c = _this.state.items) === null || _c === void 0 ? void 0 : _c[index].isActive) !== null && _d !== void 0 ? _d : index === 0, isLast: _this.props.items.length === index + 1 }));
                }),
            });
        }
    };
    WizardForm.prototype.render = function () {
        var _this = this;
        var _a, _b;
        return (React.createElement(Form, { onSubmit: this.props.onSubmit },
            this.state.items.map(function (item, index) { return (React.createElement(WizardFormItem, __assign({}, item, { id: index, key: "item-".concat(index), setActive: _this.setActive, counter: _this.state.counter }))); }),
            React.createElement(FormBar, { size: this.props.barSize, buttonLabel: this.props.edit ? (_a = getText("mary.update", "Update")) !== null && _a !== void 0 ? _a : ""
                    : (_b = getText("mary.add", "Add")) !== null && _b !== void 0 ? _b : "", title: this.props.title, isValid: this.props.isValid, hasRequiredFields: true })));
    };
    WizardForm.prototype.setActive = function (nextActive) {
        var _this = this;
        this.setState({
            counter: nextActive,
            items: this.state.items.map(function (item, index) { return (__assign(__assign({}, item), { isActive: nextActive === index, isTouched: !item.isTouched ? nextActive === index : item.isTouched })); }),
        }, function () {
            var _a, _b;
            (_b = (_a = _this.props).getCardMetrics) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.items.length > 0 ? {
                counter: _this.state.counter,
                total: _this.state.items.length,
            } : undefined);
        });
    };
    return WizardForm;
}(React.Component));
export { WizardForm };
